import { render, staticRenderFns } from "./upDownG6.vue?vue&type=template&id=2f1fa6a8&scoped=true"
import script from "./upDownG6.vue?vue&type=script&lang=js"
export * from "./upDownG6.vue?vue&type=script&lang=js"
import style0 from "./upDownG6.vue?vue&type=style&index=0&id=2f1fa6a8&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f1fa6a8",
  null
  
)

export default component.exports